import { render, staticRenderFns } from "./jdBuyShopInclude.vue?vue&type=template&id=0a817f3f"
import script from "./jdBuyShopInclude.vue?vue&type=script&lang=js"
export * from "./jdBuyShopInclude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports